/** Colección Firestore de perfiles de usuario. Document id = Firebase Auth uid. */
export const USERS_COLLECTION = 'users';
